// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__kS0Bf","spin":"loader_spin__XC5es"};